import { encodePacked } from 'viem';
const idMap = new WeakMap();
export function adapterId(info) {
    if (idMap.has(info)) {
        return idMap.get(info);
    }
    const id = encodePacked(['string', 'string', 'string'], [info.name, info.rdns ?? '', info.icon]).slice(0, 10);
    idMap.set(info, id);
    return id;
}
//# sourceMappingURL=adapter-id.js.map